import { Injectable, inject } from '@angular/core';
import { Permission, PermissionLike } from 'src/app/common/enums';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private authService = inject(AuthService);

  constructor() { }

  public hasPermissions(...permissions: PermissionLike[]) {
    return this.authService.isAuthenticated() && permissions.some((permission) => this.authService.hasPermission(permission as Permission));
  }

  public hasPermissionsOnWorkerProfile(authServerUserId: string, ...permissions: PermissionLike[]) {
    return (
      this.authService.isAuthenticated() &&
      permissions.some((permission) => this.authService.hasPermission(permission as Permission)) &&
      this.authService.authServerUserId !== authServerUserId
    );
  }
}
